import {
  filterArray,
  filterCondition,
  requireOrFilter,
} from "@west-tennessee-consulting/supabase/postgrest-filter";

/**
 * PostgREST `.or()` expression matching a contact whose primary `email` equals
 * `email` OR whose `email_aliases` contains it.
 *
 * The email is quoted as ONE value, so an address carrying `,` `(` `)` `"` or
 * `\` (all legal in a mailbox local part) cannot add a condition. Use this for
 * every "find a contact by email" query instead of interpolating.
 */
export function contactEmailMatchFilter(email: string): string {
  return requireOrFilter([
    filterCondition("email", "eq", email),
    filterArray("email_aliases", "cs", [email]),
  ]);
}
